module.exports = __webpack_public_path__ + "img/mascot-gryphon.8b1e4371.png";